import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToasterService {
  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService
  ) { }

  showError(message: string) {
    setTimeout(() => this.toastr.error(message, null));
  }

  async showErrorTranslating(message: string, values?: any) {
    const translation = await this.translateService.get(message, values).toPromise();
    this.showError(translation);
  }

  showSuccess(message: string, timeout?: number) {
    const config = timeout ? { timeOut: timeout } : {};
    setTimeout(() => this.toastr.success(message, null, config));
  }

  async showSuccessTranslating(message: string, values?: any, timeout?: number) {
    const translation = await this.translateService.get(message, values).toPromise();
    this.showSuccess(translation, timeout);
  }

  showWarning(message: string, timeout?: number) {
    const config = timeout ? { timeOut: timeout } : {};
    setTimeout(() => this.toastr.warning(message, null, config));
  }

  async showWarningTranslating(message: string, values?: any, timeout?: number) {
    const translation = await this.translateService.get(message, values).toPromise();
    this.showWarning(translation, timeout);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/toaster.service.ts